import React, { Component } from "react";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const BOTTOM_MARGIN_FOR_LOUNGE = 20;

class LoginRecommendationView extends Component {
  static propTypes = {
    onLoginRecommendationBtnClick: PropTypes.func.isRequired,
    smallBottomMarginForLounge: PropTypes.bool,
    bottomView: PropTypes.bool
  };

  static defaultProps = {
    smallBottomMarginForLounge: false,
    bottomView: false
  };

  getMarginHeight = () => {
    const { smallBottomMarginForLounge, bottomView } = this.props;

    if (getDeviceType() === "mobile") {
      return smallBottomMarginForLounge
        ? BOTTOM_MARGIN_FOR_LOUNGE
        : bottomView
        ? mobileCss.standardPaddingBetweenContent + mobileCss.headerBarHeightPX
        : mobileCss.standardPaddingBetweenContent;
    } else {
      return smallBottomMarginForLounge
        ? BOTTOM_MARGIN_FOR_LOUNGE
        : desktopCss.standardPaddingBetweenContent;
    }
  };

  getCss = () => {
    return {
      root: {
        marginBottom: this.getMarginHeight(),
        display: "flex",
        justifyContent: "center"
      }
    };
  };

  getButtonElement = () => {
    const { onLoginRecommendationBtnClick } = this.props;
    return (
      <ContainedCommonButtonView onClick={onLoginRecommendationBtnClick}>
        <TXT name="btnCommonContained_loginRecommend" />
      </ContainedCommonButtonView>
    );
  };

  render() {
    const css = this.getCss();

    return <div style={css.root}>{this.getButtonElement()}</div>;
  }
}

export default LoginRecommendationView;
